<script setup lang="ts">
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

type Props = {
  label?: string;
  name: string;
  icon?: string;
};

withDefaults(defineProps<Props>(), {
  icon: "",
  label: "",
});
</script>

<template>
  <Popover>
    <PopoverTrigger>
      <Button v-if="!icon" variant="outline" size="sm" class="text-primary border-primary h-auto px-1">{{
        label
      }}</Button>
      <i v-else :class="[`fa-solid fa-${icon} fa-xs text-primary`]" />
    </PopoverTrigger>
    <PopoverContent class="p-0">
      <slot />
    </PopoverContent>
  </Popover>
</template>
